import SubTareaService from 'src/modules/subTarea/subTareaService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'SUBTAREA_FORM';

const subTareaFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: subTareaFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await SubTareaService.find(id);
      }

      dispatch({
        type: subTareaFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subTareaFormActions.INIT_ERROR,
      });

      getHistory().push('/sub-tarea');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: subTareaFormActions.CREATE_STARTED,
      });

      await SubTareaService.create(values);

      dispatch({
        type: subTareaFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.subTarea.create.success'),
      );

      getHistory().push('/sub-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subTareaFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: subTareaFormActions.UPDATE_STARTED,
      });

      await SubTareaService.update(id, values);

      dispatch({
        type: subTareaFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.subTarea.update.success'),
      );

      getHistory().push('/sub-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: subTareaFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default subTareaFormActions;
